import {api} from './api';
import {Calendar, GoogleCalendar, Reminder} from '../types';

export const calendarService = {
  async getAvailableCalendars(): Promise<GoogleCalendar[]> {
    const response = await api.get<{calendars: GoogleCalendar[]}>(
      '/api/v1/calendars/available',
    );
    return response.calendars;
  },

  async getUserCalendars(): Promise<Calendar[]> {
    const response = await api.get<{calendars: Calendar[]}>(
      '/api/v1/calendars',
    );
    return response.calendars;
  },

  async addCalendar(googleCalendarId: string): Promise<Calendar> {
    return api.post<Calendar>('/api/v1/calendars', {googleCalendarId});
  },

  async updateCalendar(calendarId: string, isActive: boolean): Promise<Calendar> {
    return api.patch<Calendar>(`/api/v1/calendars/${calendarId}`, {isActive});
  },

  async removeCalendar(calendarId: string): Promise<void> {
    await api.delete(`/api/v1/calendars/${calendarId}`);
  },

  async getReminders(days: number = 7): Promise<Reminder[]> {
    const response = await api.get<{reminders: Reminder[]}>(
      `/api/v1/reminders?days=${days}`,
    );
    return response.reminders;
  },
};
